import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import { useTranslationX } from 'i18n';
import { PlayItemData, TeamData } from 'types';
import { classes, gtag } from 'utils';
import { VS } from 'assets/vector';

import bg from 'assets/images/item_bg.png';
import styles from './PlayItem.module.scss';

type Props = {
  data: PlayItemData;
};

const PlayItem = ({ data }: Props) => {
  const { homePosition, home, away, apiName, event } = data;
  const { status, scheduled, period, pathname } = data;
  const { tx } = useTranslationX('play.item');

  const navigate = useNavigate();
  const hasEvent = event?.length;

  let rightTeam = home;
  let leftTeam = away;
  let s1, s2;
  let isLive = false;

  switch (status) {
    case 'scheduled':
      s1 = moment(scheduled).format('MMM DD');
      s2 = moment(scheduled).format('LT');
      break;

    case 'inprogress':
    case 'live':
      isLive = true;
      s1 = tx('live');
      s2 = period && period !== 'undefined' ? period : '-';
      break;

    case 'final':
      s2 = status;
      break;
  }

  if (homePosition === 'left') {
    rightTeam = away;
    leftTeam = home;
  }

  const renderTeam = ({ name, logo, score }: TeamData, reverse?: boolean) => (
    <div className={classes(styles.team, reverse ? styles.reverse : '')}>
      <div className={styles.wrapper}>
        <div
          className={styles.logo}
          style={logo ? { backgroundImage: `url(${logo})` } : undefined}
        />

        <div className={styles.name}>{name}</div>
      </div>

      <div className={styles.score}>
        <span>{typeof score === 'number' || isLive ? score || 0 : '-'}</span>
      </div>
    </div>
  );

  return (
    <div
      className={classes(
        styles.playItem,
        isLive ? styles.live : '',
        hasEvent ? styles.event : ''
      )}
      style={{ backgroundImage: `url(${bg})` }}
      onClick={
        hasEvent
          ? () => {
              gtag('event', `game_${pathname}_cliked`);
              navigate(`/play/${pathname}`);
            }
          : undefined
      }
    >
      <div className={styles.header}>{apiName}</div>

      <div className={styles.body}>
        {renderTeam(leftTeam)}

        <div className={styles.info}>
          <div className={styles.vs}>
            <VS />
          </div>
          <div
            className={styles.s1}
            style={s1 ? undefined : { backgroundColor: 'transparent' }}
          >
            {s1}
          </div>
          <div
            className={styles.s2}
            style={s2 ? undefined : { backgroundColor: 'transparent' }}
          >
            {s2}
          </div>
        </div>

        {renderTeam(rightTeam, true)}
      </div>
    </div>
  );
};

export default PlayItem;
